import React from "react";
import { Container } from "react-bootstrap";

const JoinUsHero = () => {

  return (
    <section className="join-us hero-section d-flex align-items-center justify-content-center">
      <Container fluid>
        <div className="content-block mb-3">
          <h2 className="text-white ft-wt-700 mb-3 mb-lg-2 big-title">
            Join Our Team
          </h2>
          <p className="text-white mb-4">
            We are always looking for talented individuals to join our team. If you are passionate about technology and want to make a difference, we would love to hear from you.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default JoinUsHero;
